import {api} from '@/services/http/api'

let instance = new AbortController()

export const ApiAbortControllerService = {
  getSignal: () => instance.signal,

  abort: () => {
    instance.abort()
    instance = new AbortController()
    api.defaults.signal = instance.signal
  },
}
